// ink-component
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { CoreVerticalNavElement } from '../../_common/CoreVerticalNavElement';

export interface VerticalNavItemProps extends React.HTMLAttributes<HTMLElement> {
  /** Defines the active state */
  active?: boolean;
  /** Wrap or ellipse the test */
  whiteSpace?: string;
  /** Render prop for rendering custom items, like React router's Link */
  render: any;
}

/**
 * @group VerticalNav
 * @purpose Renders custom element via render prop
 * @order 3
 */
export function VerticalNavItem(props: VerticalNavItemProps) {
  const { active, whiteSpace, className, render, style, ...otherProps } = props;
  const { props: renderProps, type } = render();
  const { className: renderClass, style: renderStyle, ...renderOtherProps } = renderProps;

  const currentTheme = useContext(ThemeContext);
  const theme = { ...currentTheme, active, whiteSpace };

  return <CoreVerticalNavElement theme={theme} {...otherProps} {...renderOtherProps} tabIndex={0} as={type} />;
}

VerticalNavItem.defaultProps = {
  active: undefined,
  whiteSpace: undefined,
  render: undefined,
};

VerticalNavItem.displayName = 'VerticalNav.Item';

export default VerticalNavItem;
